import { get } from "api";
import { Models } from "api/types";

export const hasSelectableRewards = async (
  membershipId: string
): Promise<boolean> => {
  try {
    const membership = await get("/memberships/{membershipId}", {
      membershipId,
    });

    return (
      membership.membershipRewardGroups?.some(
        (rg: Models<"MembershipRewardGroupModel">) => rg.hasSelectableRewards
      ) ?? false
    );
  } catch (error) {
    console.error(
      `Failed to check selectable rewards for membership ${membershipId}:`,
      error
    );
    return false;
  }
};

export const orderContainsSelectableRewards = async (
  order: Models<"ShopDisplayOrderResult">
): Promise<boolean> => {
  if (!order.shopDisplayOrderLineItems) return false;

  const membershipIds = order.shopDisplayOrderLineItems
    .filter((item) => item.shopDisplayMembershipId != null)
    .map((item) => item.shopDisplayMembershipId)
    .filter((id): id is string => id != null);

  if (membershipIds.length === 0) return false;

  for (const membershipId of membershipIds) {
    if (await hasSelectableRewards(membershipId)) {
      return true;
    }
  }

  return false;
};
